<template>
  <div class="songplay">
    <div class="row">
      <div class="left col-md-8 float-left pl-0 pr-0">
        <player
          @songSameSinger="songSameSinger = $event"
          @songSameCategory="songSameCategory = $event"
          @modalMessage="modalMessage=$event"
        ></player>

        <div class="othersong mt-5">
          <div class="col-md-6 float-left pl-0 pr-1">
            <same-singer :song-list="songSameSinger"></same-singer>
          </div>

          <div class="col-md-6 float-right pr-1 pl-0">
            <same-category :song-list="songSameCategory"></same-category>
          </div>
        </div>
      </div>

      <div class="right col-md-4 float-right pr-1 pl-1">
        <ringbacktone-top></ringbacktone-top>
        <div class="mt-5"></div>

        <music-top></music-top>

        <div class="ads" v-for="item in adv">
          <a :href="item.link">
            <img :src="item.image"/>
          </a>
        </div>
      </div>
      <div class="parent expand" style="clear: both"></div>
    </div>

    <partner></partner>

    <modal :modal-title="modalTitle" :modal-message="modalMessage"></modal>
  </div>
</template>

<script>
  import Player from './Player'
  import SameSinger from './SameSinger'
  import SameCategory from './SameCategory'
  import MusicTop from '../../home/web/MusicTop'
  import RingbacktoneTop from '../../home/web/RingbacktoneTop'
  import Partner from '../../home/wap/Partner'

  export default {
    name: "SongPlay",
    components: {
      "player": Player,
      "same-singer": SameSinger,
      "same-category": SameCategory,
      "music-top": MusicTop,
      "ringbacktone-top": RingbacktoneTop,
      "partner": Partner
    },
    data () {
      return {
        songSameSinger: [],
        songSameCategory: [],
        adv: [],
        modalMessage: "",
        modalTitle: "Thông báo"
      }
    },
    methods: {
      getListAdv(){
        this.adv = [];
        axios.post(api.adv)
          .then(response => {
            var result = response.data.result;
            result.forEach(item => {
              if(item.page == "play" && item.position == 1){
                this.adv.push(item);
              }
            });
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    watch:{
      "$route.path": {
        handler: "getListAdv",
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .right{
    margin-top: -15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/songplay/wap/SongPlay.vue